import * as React from "react"

function SpeedoBackground(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={416} height={319} viewBox="0 0 416 319" {...props}>
      <title>{"Group 7"}</title>
      <defs>
        <ellipse id="prefix__a" cx={208} cy={208.5} rx={208} ry={208.5} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 4)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            d="M184.725-12l2.797 25.205M162.35-8.265l5.594 24.271m-27.97-17.737l8.39 23.338M119.462 6.671l9.323 22.405M98.017 16.94l12.12 21.47M79.37 29.077l13.985 20.537m-32.632-5.6l16.782 18.67m-32.632-1.867L63.52 77.619m-34.497.934l20.512 14.003M6.647 117.76l23.309 9.336m-31.7 12.136l24.24 8.401m-29.834 14.003l24.24 5.602m-27.778 17.832l23.907 2.55M-12 207.867h24.038m-22.809 22.789l23.906-2.55m-20.473 25.019l24.24-5.601m-18.646 28.94l24.24-8.403M7.58 297l23.309-9.335m379.465 8.401l-23.309-9.335m31.7-11.202l-24.24-8.402m29.834-14.937l-24.24-5.6m27.777-17.797l-23.906-2.55M429 205.998h-24.038m22.809-22.79l-23.906 2.55m20.473-25.055l-24.24 5.601m18.646-28.006l-24.24 8.402m14.917-29.873l-23.309 9.335m.932-48.544l-20.511 14.003m5.594-31.74L353.48 76.686m1.865-33.607l-16.783 18.67m-1.864-33.607L322.712 48.68m-4.661-32.674l-12.12 21.471m-8.392-30.806l-9.323 22.405m-12.12-31.74l-8.392 24.271M253.719-8.266l-5.594 24.272M231.342-12l-2.797 25.205"
            stroke="#FEFEFE"
            mask="url(#prefix__b)"
          />
        </g>
        <path fill="#FEFEFE" d="M206 24h3V0h-3z" />
        <path
          stroke="#FEFEFE"
          strokeWidth={3}
          d="M24 105l21 12M25 317l21-12M393 316l-21-12M392 105l-21 12"
        />
      </g>
    </svg>
  )
}

export default SpeedoBackground
